export default __webpack_public_path__ + "static/media/romance.c8916a31.png";